import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteProduct = async (productId: string): Promise<boolean> =>
  axios.delete(`/management/product/removeproduct?productId=${productId}`).then((res) => res?.data?.result)

type Props = {
  productId: string
}

export const useManagementDeleteProduct = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteProduct'],
    mutationFn: ({ productId }: Props) => deleteProduct(productId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted product type.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete product type, please try again.')
      }
    },
    throwOnError: false
  })
